import React from 'react';

interface MonthTotalListsProps {
  totalMonth: number;
  card: number;
  cash: number;
  etc: number;
  showMileage?: boolean;
}

const MonthTotalLists = ({
  card,
  cash,
  etc,
  totalMonth,
  showMileage = true,
}: MonthTotalListsProps) => {
  return (
    <div className="month_total_lists_container">
      <div className="sales_wrapper purple">
        <span className="title">총 매출</span>
        <span className="money">{totalMonth.toLocaleString('ko-KR')}</span>
      </div>

      <div className="sales_wrapper red">
        <span className="title">신용카드</span>
        <span className="money">{card.toLocaleString('ko-KR')}</span>
      </div>

      {showMileage && (
        <div className="sales_wrapper green">
          <span className="title">마일리지</span>
          <span className="money">{cash.toLocaleString('ko-KR')}</span>
        </div>
      )}

      <div className="sales_wrapper orange">
        <span className="title">신용기타</span>
        <span className="money">{etc}</span>
      </div>
    </div>
  );
};

export default MonthTotalLists;
